import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class SubItem2 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item2">
                <Row style={{backgroundColor: "f4f4f4", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Oportunidades de trabajo</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El profesional egresado de nuestra institución tiene capacidades que le permiten ingresar a un amplio mercado laboral en áreas específicas como: Agencias de Publicidad, Medios de Comunicación Social, Empresas de Investigación de Mercado, Empresas de Marketing, Estudios Creativos,  Emprendedor Independiente, Consultor y Asesor.
                        </div>
                    </Col>
                    <Col md={4}>
                    
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem2;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/SubItem2.jsx